<style scoped>
  .position-relative {
    position: relative !important;
  }

  .sidebar-toggle {
    position: absolute !important;
    margin-left: -55px;
    margin-top: 12px;
    z-index: 999;
    background-color: transparent;
    border: 0px;
    color: #6c757d;
    font-weight: bold;
    font-size: 18px;
    box-shadow: none;
    padding-top: 25px;
  }

  .sidebar-toggle:focus {
    box-shadow: none !important;
  }

  .sidebar-toggle:active {
    background-color: transparent !important;
    color: #4e555b !important;
  }

  .sidebar-toggle.toggle-hidden {
    margin-left: -15px;
    background-color: #6c757d;
    color: #fff;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    font-size: 14px;
  }

  .main {
    min-height: calc(100vh - 310px);
    position: relative;
  }

  .sidebar-container {
    padding-top: 20px !important;
  }

  @media (max-width: 767px) {
    .sidebar-toggle {
      margin-left: 0px;
    }

    .sidebar-toggle.toggle-hidden {
      margin-left: 0px;
      margin-top: 0px;
      border-top-left-radius: 0;
      border-top-right-radius: 0;
      border-bottom-left-radius: 0.25rem;
    }

    .sidebar-toggle .mobile {
      display: inline-block;
    }

    .sidebar-toggle .desktop {
      display: none !important;
    }
  }

  @media (min-width: 768px) {
    .sidebar-toggle .mobile {
      display: none !important;
    }

    .sidebar-toggle .desktop {
      display: inline-block;
    }
  }
</style>

<template>
  <b-row>
    <side-bar
      :show-sidebar="showSidebar"
      :title="title"
      :items="items"
      :currValidationResult="currValidationResult"
      class="col-sm-12 col-md-3 col-lg-3 col-xl-2"
    >
    </side-bar>
    <main v-bind:class="mainContainerClass" class="main">
      <b-button
        ref="toggleBtn"
        v-on:click="toggleSidebar"
        v-bind:class="toggleBtnHiddenClass"
        class="sidebar-toggle"
      >
        <span class="sr-only">Show or hide sidebar</span>
        <font-awesome-icon icon="list" v-if="!showSidebar" />
        <span v-if="showSidebar">
          <font-awesome-icon icon="angle-up" class="mobile" />
          <font-awesome-icon icon="angle-left" class="desktop" />
        </span>
      </b-button>
      <b-row>
        <b-col>
          <slot></slot>
        </b-col>
      </b-row>
    </main>
  </b-row>
</template>

<script>
import jshelper from '@/libs/helper';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faList, faAngleUp, faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import Sidebar from '@/components/base/sidebar/components/Sidebar';

library.add(faList, faAngleUp, faAngleLeft);

export default {
  components: {
    'side-bar': Sidebar,
  },
  props: {
    title: String,
    formData: Object,
    mapper: {
      type: Object,
      default() { return null; },
    },
    objectHandler: Function,
    arrayHandler: Function,
    currValidationResult: Object,
  },
  data() {
    return {
      showSidebar: true,
    };
  },
  mounted() {
    window.onresize = () => {
      this.showSidebar = window.innerWidth > 768;
    };
  },
  computed: {
    mainContainerClass() {
      if (this.showSidebar) {
        return 'col-sm-12 col-md-9 col-lg-9 col-xl-10';
      }
      return 'col-md-12';
    },
    toggleBtnHiddenClass() {
      return this.showSidebar ? '' : 'toggle-hidden';
    },
    items() {
      const items = [];
      Object.keys(this.formData).forEach((key) => {
        let shouldHide = false;
        try {
          shouldHide = this.mapper[key].hide === true;
        } catch (_) {
          shouldHide = false;
        }

        if (!shouldHide && Object.prototype.hasOwnProperty.call(this.formData, key)) {
          const item = {};
          item.stepName = this.resolveKey(key);
          item.fields = [];
          Object.keys(this.formData[key]).forEach((innerKey) => {
            const innerValue = this.formData[key][innerKey];
            if (typeof innerValue === 'boolean' || (innerValue && !jshelper.isEmpty(innerValue))) {
              const field = {};
              field.name = this.resolveKey(key, innerKey);
              field.value = this.processedValue(innerValue);
              item.fields.push(field);
            }
          });

          items.push(item);
        }
      });

      return items;
    },
  },
  methods: {
    toggleSidebar() {
      this.$refs.toggleBtn.blur();
      this.showSidebar = !this.showSidebar;
    },
    resolveKey(key, innerKey) {
      if (!key) { return ''; }

      if (this.mapper && this.mapper[key]) {
        if (innerKey && this.mapper[key].items[innerKey]) {
          return this.mapper[key].items[innerKey];
        }

        return this.mapper[key].title;
      }

      return this.processedKey(innerKey || key);
    },
    processedKey(key) {
      let splittedCamelCase = key.replace(/([a-z])([A-Z])/g, '$1 $2');
      splittedCamelCase = splittedCamelCase.charAt(0).toUpperCase() + splittedCamelCase.slice(1);
      return splittedCamelCase;
    },
    processedValue(value) {
      if (typeof value === 'boolean') { return jshelper.readableBool(value); }
      if (!value) { return ''; }
      if (typeof value === 'object') {
        if (value.constructor === Array) {
          return this.arrayHandler(value);
        }

        return this.objectHandler(value);
      }
      if (typeof value !== 'string') { return value; }

      return value.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/base/sidebar/components/BaseWithSidebar.vue